export default "__VITE_ASSET__BamBajEg__"